import { Button } from '@nextui-org/react';
import { signOut } from 'common/src/api/auth';
import useUserStore from 'common/src/stores/useUserStore';

const DemoExpired = () => {
  const { clearUserProfile } = useUserStore();

  const handleLogout = () => {
    signOut();
    clearUserProfile();
  };

  return (
    <div className='h-screen w-screen flex items-center justify-center bg-background'>
      <div className='max-w-md text-center p-8'>
        {/* design-ignore: emoji decorativo de la pantalla de demo vencida */}
        <div className='text-6xl mb-6'>🍒</div>
        {/* design-ignore: pantalla de demo vencida, fuera del layout de la app */}
        <h1 className='text-2xl font-bold mb-4'>Se acabó tu demo</h1>
        <p className='text-default-500 mb-8'>
          Tu periodo de prueba ha finalizado. Escribe a Juan Pablo, a{' '}
          <a
            href='mailto:jp@cherrymarket.cl'
            className='text-brand-600 font-medium hover:underline'
          >
            jp@cherrymarket.cl
          </a>{' '}
          para contratar.
        </p>
        <div className='flex flex-col gap-3'>
          <Button
            color='primary'
            size='lg'
            onPress={() =>
              window.open('mailto:jp@cherrymarket.cl', '_self')
            }
          >
            Escribir a Juan Pablo
          </Button>
          <Button variant='light' onPress={handleLogout}>
            Cerrar sesión
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DemoExpired;
